import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import { Box } from '@common-fe/common-fe';

import ROUTES from '@/common/routes';
import { useBreadcrumbs } from '@/modules/core/hooks';
import { HealthPlanSpendTrackerDetails } from '@/modules/deductibles/HealthPlanDetails/HealthPlanSpendTrackerDetails';
import theme from '@/styles/theme';

const HealthPlanSpendTrackerDetailsPage = () => {
  const { healthPlanId, yearId } = useParams<{ healthPlanId: string, yearId: string }>();
  const [healthPlanName, setHealthPlanName] = useState<string>();

  useBreadcrumbs([
    {
      key: ROUTES.HOME,
      title: 'Home',
      value: ROUTES.HOME,
    },
    {
      key: ROUTES.HEALTH_PLAN_SPENDS_DETAILS(healthPlanId, yearId),
      title: healthPlanName || '',
      value: ROUTES.HEALTH_PLAN_SPENDS_DETAILS(healthPlanId, yearId),
    },
  ], true);

  return (
    <Box width="100%" margin={{ top: '0' }} height="fit-content">
      <Box align="center" pad={{ horizontal: '40px' }} margin={{ top: 'medium' }}>
        <Box width={theme.defaultContentWidth}>
          <HealthPlanSpendTrackerDetails
            healthPlanName={healthPlanName}
            yearId={yearId}
            onHealthPlanNameChange={setHealthPlanName}
          />
        </Box>
      </Box>
    </Box>
  );
};

export default HealthPlanSpendTrackerDetailsPage;
